angular
  .module("digitalLeasing.module")
  .component("downloadsAcceptance", {
    templateUrl: "ng/components/digitalLeasing/acceptance/downloadsAcceptance/downloadsAcceptance.view.html",
    controllerAs: "downloadsAcceptanceCtrl",
    bindings: {
      preventivo: "<",
      checkDownloadInfo: "&?",
      tableName: "<",
      columnName: "<",
      firstDownloadList: "<",
      reteVendita: "<",
      snapshot: '<',
      financialModel: '<'
    },
    controller: function (
      $uniService,
      $simulationService,
      $configService,
      $portalService,
      $download
    ) {
      var self = this;

      self.urls = [{}];


      self.$onInit = function () {

        self.$portalService = $portalService;

      };

      self.$onChanges = function (changed) {
        if (changed.firstDownloadList && changed.firstDownloadList.currentValue) {
          self.urls = changed.firstDownloadList.currentValue;
          checkedDownload();
        }
      }


      self.getDownloadsList = function () {
        if (self.snapshot) {
          return;
        }
        if (!self.preventivo.numero && !self.preventivo.anno) {
          return;
        }

        if (!self.preventivo.numero && !self.preventivo.anno) {
          return;
        }

        $simulationService
          .populateCheckListTrasparenza(self.preventivo, self.reteVendita, self.financialModel.leasingData.id)
          .then(function (response) {

            if (response.success) {
              self.urls = response.metadataUniUpload.downloadFile;
              checkedDownload();
            }

          })
          .catch(function (error) {
            console.log("ERROR: ", error);
          })
          .finally(function () {
            console.log("Andata!")
          })

      }

      self.getUrls = function () {
        if (self.snapshot) {
          return;
        }
        $uniService
          .getUrlsDoc(self.cdTipoProdotto)
          .then(function (response) {

            self.urls = response
              .map(function (element) {
                return {
                  value: element.value
                }
              })
              .filter(function (values) {
                return values.value.replace(/\\/g, "");
              });
          })
          .catch(function (error) {
            console.log("Error", error);
          })
          .finally(function () {
            self.parseValues();
            console.log("Url recuperate");
          });
      };


      self.generateDownloadLink = function (index) {
        var url = "/uni/downloadDoc/service-infos/FINANCIAL_DOWN_DOC/" +
          encodeURIComponent(self.preventivo.anno) +
          "/" +
          encodeURIComponent(self.preventivo.numero) +
          "/" +
          encodeURIComponent(self.urls[index].codiceBene.replace(/_/g, "")) + "/"

        $download.getGenericDownload(url)
          .then(function (response) {
            console.log(response);
          })
      };



      self.parseValues = function () {
        self.urls.forEach(function (e) {

          e.value = JSON.parse(e.value);

        })

      }


      self.downloadDoc = function (index) {
        self.urls[index].buttonUpload = true;
        var input = {
          downloadKey: self.urls[index].linkDoc
        }
        var url = "/uni/downloadDoc/service-infos/"
        $download.getGenericDownload(url, input)
          .then(function (response) {
            console.log(response)
          })
        enableDisabledButton();

      };

      var checkedDownload = function () {
        if ($portalService.isAra()) {
          self.urls.forEach(function (elem) {
            elem.buttonUpload = elem.downloaded;
          })
          enableDisabledButton();
        }


      }

      var enableDisabledButton = function () {
        var testAllDocumentDownload = self.urls.every(function (element) {
          return element.buttonUpload == true;
        })
        if (testAllDocumentDownload) {
          self.checkDownloadInfo({
            isInfo: true
          });

        }
      }

      self.checkDownloadedDocs = function (index) {
        self.urls[index].buttonUpload = true;
        enableDisabledButton();
      }

    }
  });